import { AppShell } from '../components/layout/AppShell.js';
import { Card } from '../components/ui/card.js';

export function CronHandlerPage() {
  return (
    <AppShell>
      <div className="space-y-8">
        <div>
          <div className="eyebrow">Admin / Cron handler</div>
          <h1 className="font-display text-[40px] font-medium leading-none tracking-[-0.02em]">
            Cron handler
          </h1>
          <p className="mt-3 font-mono text-[11px] text-muted-foreground">
            Scheduled jobs — manual triggers, run history, and on/off toggles.
          </p>
        </div>

        <Card className="p-6">
          <div className="font-mono text-[12px] text-muted-foreground">
            Coming soon — list of scheduled jobs with last-run timestamp, next-run ETA,
            status, and a "Run now" action per job.
          </div>
        </Card>
      </div>
    </AppShell>
  );
}
